module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/has-binary/~/isarray/index.js
// module id = 1711
// module chunks = 47